export const validation = {
  adminEmail: 'Please enter admin email',
};
